import { render, staticRenderFns } from "./LeagueRatingDescription.vue?vue&type=template&id=3aef5935&scoped=true&"
import script from "./LeagueRatingDescription.vue?vue&type=script&lang=js&"
export * from "./LeagueRatingDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aef5935",
  null
  
)

export default component.exports